module.exports = __webpack_public_path__ + "img/Illustration - ID@3x.f489a159.png";